/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanUnit } from './PlanUnit';
import {
    PlanUnitFromJSON,
    PlanUnitFromJSONTyped,
    PlanUnitToJSON,
    PlanUnitToJSONTyped,
} from './PlanUnit';

/**
 * 
 * @export
 * @interface CreateTrainingPlan
 */
export interface CreateTrainingPlan {
    /**
     * 
     * @type {string}
     * @memberof CreateTrainingPlan
     */
    title: string;
    /**
     * 
     * @type {Array<PlanUnit>}
     * @memberof CreateTrainingPlan
     */
    units: Array<PlanUnit>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTrainingPlan
     */
    unlockMode: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTrainingPlan
     */
    allowUsersToRateWorkout: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateTrainingPlan
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTrainingPlan
     */
    trainingDateIso?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTrainingPlan
     */
    editorIds: Array<string>;
}

/**
 * Check if a given object implements the CreateTrainingPlan interface.
 */
export function instanceOfCreateTrainingPlan(value: object): value is CreateTrainingPlan {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('units' in value) || value['units'] === undefined) return false;
    if (!('unlockMode' in value) || value['unlockMode'] === undefined) return false;
    if (!('allowUsersToRateWorkout' in value) || value['allowUsersToRateWorkout'] === undefined) return false;
    if (!('editorIds' in value) || value['editorIds'] === undefined) return false;
    return true;
}

export function CreateTrainingPlanFromJSON(json: any): CreateTrainingPlan {
    return CreateTrainingPlanFromJSONTyped(json, false);
}

export function CreateTrainingPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTrainingPlan {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'units': ((json['units'] as Array<any>).map(PlanUnitFromJSON)),
        'unlockMode': json['unlockMode'],
        'allowUsersToRateWorkout': json['allowUsersToRateWorkout'],
        'description': json['description'] == null ? undefined : json['description'],
        'trainingDateIso': json['trainingDateIso'] == null ? undefined : json['trainingDateIso'],
        'editorIds': json['editorIds'],
    };
}

export function CreateTrainingPlanToJSON(json: any): CreateTrainingPlan {
    return CreateTrainingPlanToJSONTyped(json, false);
}

export function CreateTrainingPlanToJSONTyped(value?: CreateTrainingPlan | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'units': ((value['units'] as Array<any>).map(PlanUnitToJSON)),
        'unlockMode': value['unlockMode'],
        'allowUsersToRateWorkout': value['allowUsersToRateWorkout'],
        'description': value['description'],
        'trainingDateIso': value['trainingDateIso'],
        'editorIds': value['editorIds'],
    };
}

